import pageStateService from 'core/PageState.service';
import { withRouter } from 'core/withRouter';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageUtil from 'utils/Page.util';
import ProductUpdateV from './Product.update.v';
import { ProductDTO } from 'models/product';
import productService from 'services/product.service';

class Params {
    error: string = null;
    isLoaded: boolean = false;

    item: ProductDTO = new ProductDTO();
}

function ProductUpdate(props: any) {
    const navigate = useNavigate();
    const [params, setParams] = useState(new Params());
    const id = props?.params?.id;
    const isUpdate: boolean = id ? true : false;
    // 중복요청방지
    const [isSubmitting, setIsSubmitting] = useState(false);

    /* ***************************************************************************************** */
    /* ************************************* STATE ********************************************* */
    /* ***************************************************************************************** */
    //onMount
    useEffect(() => {
        getData();

        return () => { };
    }, []);

    /* ***************************************************************************************** */
    /* ************************************* BASIC ********************************************* */
    /* ***************************************************************************************** */
    async function getData() {
        if (id && isUpdate) {
            try {
                const res = await productService.get(id);
                console.log('res {getData}', res);

                const curParams = PageUtil.deepCopy(params) as Params;
                curParams.isLoaded = true;
                curParams.item = res;

                setParams(curParams);
            } catch (error) {
                setParams((prev) => ({
                    ...prev,
                    isLoaded: true,
                    error: error,
                }));

                PageUtil.handleApiError(error);
            }
        } else {
            const item = new ProductDTO();
            // 신규 등록시 기본값 설정
            item.isActive = true;

            setParams((params) => ({
                ...params,
                isLoaded: true,
                item: item,
            }));
        }
    }

    async function submit() {
        if (isSubmitting) return;

        const dto = PageUtil.deepCopy(params.item) as ProductDTO;

        if (!dto.productCode) {
            alert('제품코드를 입력해 주세요.');
            return;
        }

        if (!dto.productName) {
            alert('제품명을 입력해 주세요.');
            return;
        }

        if (!dto.category) {
            alert('카테고리를 선택해 주세요.');
            return;
        }

        if (!dto.useType) {
            alert('용도를 선택해 주세요.');
            return;
        }

        if (!dto.price || dto.price < 0) {
            alert('판매가를 올바르게 입력해 주세요.');
            return;
        }

        if (dto.costPrice && dto.costPrice < 0) {
            alert('원가를 올바르게 입력해 주세요.');
            return;
        }

        console.log('submit', params.item, dto, isUpdate);

        setIsSubmitting(true);

        try {
            await productService.save(dto);
            alert('완료되었습니다.');

            history.back();
            // pageStateService.clearPageState();
            // navigate('/product', { replace: true });
        } catch (error) {
            setParams((prev) => ({
                ...prev,
                error: error,
            }));

            PageUtil.handleApiError(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    async function remove() {
        if (isSubmitting) return;

        if (!confirm('삭제하시겠습니까?')) return;
        setIsSubmitting(true);

        try {
            await productService.remove(id);
            alert('완료되었습니다.');

            pageStateService.clearPageState();
            navigate('/product', { replace: true });
        } catch (error) {
            setParams((prev) => ({
                ...prev,
                error: error,
            }));

            PageUtil.handleApiError(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    /* ***************************************************************************************** */
    /* ************************************** VAC ********************************************** */
    /* ***************************************************************************************** */
    const args = {
        params: params,
        setParams: setParams,
        isUpdate: isUpdate,

        handleChange: PageUtil.handleChange,

        submit: submit,
        remove: remove,
    };

    return <ProductUpdateV {...args} />;
}

export default withRouter(ProductUpdate, [productService]);